"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var equivalent = function equivalent(args1, args2) {
  return args1.every(function (arg, i) {
    return arg === args2[i];
  });
};

var _default = equivalent;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(equivalent, "equivalent", "src/utilities/equivalent.js");

  __REACT_HOT_LOADER__.register(_default, "default", "src/utilities/equivalent.js");
}();

;


// WEBPACK FOOTER //
// /Users/david/Source/react-formality/lib/utilities/equivalent.js